import React, { useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone } from '@fortawesome/free-solid-svg-icons'

import Form from '../../components/en/form'
config.autoAddCss = false

const Contact = () => {
  const [name, setName] = useState('{name}')
  const [project, setProject] = useState('{project title}')
  const [contact, setContact] = useState('{contact details}')

  const handleChange = (property, value) => {
    switch (property) {
      case 'name':
        value === '' ? setName('{name}') : setName(value)
        return
      case 'project':
        value === '' ? setProject('{project title}') : setProject(value)
        return
      case 'contact':
        value === '' ? setContact('{contact details}') : setContact(value)
        return
      default:
        return
    }
  }

  return (
    <Container fluid className="contact-bg h-700" id="kontakt">
      <Row>
        <div className="col-12">
          <div className="container bg-white shadow" style={{ position: 'relative', top: '-30%' }}>
            <div className="row">
              <Col className="col-10 offset-1">
                <div className="row mt-5 mb-5 pt-5 pb-3">
                  <div className="col-12 mb-5">
                    <h2>Get in touch!</h2>
                  </div>
                  <div className="col-12 col-md-6">
                    <Form onChange={handleChange} />
                  </div>
                  <div className="col-12 col-md-5 offset-md-1 mt-5 mt-md-0">
                    <span id="mailcontent">
                      <p>
                        <strong>Hello ganztags.</strong>
                      </p>
                      <p>
                        My name is <span id="name">{name}</span> and I would like your help with{' '}
                        <span id="projekt">{project}</span>. Please contact me via <span id="email">{contact}</span>.
                      </p>
                    </span>
                    <p className="mt-3 pt-3 pb-5 mb-5">
                    Alternatively, you can write an email directly to hallo@ganztags.net.*
                    </p>
                    <p className="small mt-5 pt-5 mb-0">
                    *We are not reachable by phone for initial inquiries. Following the recent depletion of our fax ribbon, we discarded our phones as well. However, a direct exchange via Meets, Zoom or a similar platform is, of course, not a problem.
                    </p>
                  </div>
                </div>
              </Col>
            </div>
          </div>
        </div>
      </Row>
    </Container>
  )
}

export default Contact
